import ISetupPageProps from "./setupPage.interface";
import { SkyDivider, SkyLink, SkyLoader } from "@skypointcloud/skypoint-ui";

const SetupPage = (props: ISetupPageProps) => {
  const { isSetupFinished } = props;
  return (
    <>
      <div
        className="form-box w-[750px] font-[Arial,Helvetica,sans-serif]"
        id="login-box"
      >
        <div className="header with-border">
          <h3 className="box-title">
            <p className="logo-lg">
              <img
                src="dist/img/skyPoint-logo-text-white.svg"
                className="w-[180px]"
              />
            </p>
            Welcome to Skypoint
          </h3>
        </div>
        <div className="body bg-white dark:bg-gray-900 left-0">
          <div className="text-center">
            <h3>
              <span>
                <strong>
                  Talk to your data and uncover key insights with Skypoint AI Platform.
                </strong>
              </span>
            </h3>
            <p></p>
            <p>pay-per-use solution that closes the gap between individuals and information.</p>
          </div>
          <SkyDivider />
          <h4 className="callout callout-warning text-center">
            Do not close or refresh the page until the setup is completed.
          </h4>
          {!isSetupFinished && (
            <h4 className="callout callout-info text-center">
              It will take a few moments to set up your account.&nbsp;&nbsp;
              <span>
                <SkyLoader size="tiny" />
              </span>
            </h4>
          )}
          <div className="col-md-12">
            <div
              className="alert alert-success hidden"
              id="successMessage"
            ></div>
            <div
              className="alert alert-danger hidden"
              id="errorMessage"
            ></div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="info-box">
                <div className="box-body">
                  <span className="info-box-icon bg-white">
                    <img
                      src="dist/img/billingicon.jpg"
                      className="img-80"
                      alt="empty metrics"
                    />
                  </span>
                  <div className="info-box-content dashboard">
                    <div className="dashborad-header p-0">Step 1. Choose a plan</div>
                    <div>
                      <p>
                        Skypoint offers a free 14-day trial. By default, the free plan will be
                        selected. You can contact the &nbsp;
                        <SkyLink
                          href="https://skypointcloud.com/customer-support/"
                          target="_blank"
                        >
                          Skypoint support team
                        </SkyLink>
                        &nbsp; to upgrade it to avail more benefits.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-12">
              <div className="info-box">
                <div className="box-body">
                  <span className="info-box-icon bg-white">
                    <img
                      src="dist/img/azurestorage.jpg"
                      className="img-80"
                      alt="empty metrics"
                    />
                  </span>
                  <div className="info-box-content dashboard">
                    <div className="dashborad-header p-0">
                      Step 2. Configure your storage account
                    </div>
                    <div>
                      <p>
                        A default azure storage account will be provided to store your valuable
                        data. You can change your storage account from the Settings page.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-12">
              <div className="info-box">
                <div className="box-body">
                  <span className="info-box-icon bg-white">
                    <img
                      src="dist/img/tenant-icon2.png"
                      className="img-80"
                      alt="empty metrics"
                    />
                  </span>
                  <div className="info-box-content dashboard">
                    <div className="dashborad-header p-0">Step 3. Create tenant and instance</div>
                    <div>
                      <p>
                        A new tenant and instance will be created with the default configuration.
                        You can change the configuration from the Settings page.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SetupPage;
